import React, { Component } from 'react';
import ClaveRegimenAduanero from '../../../support/catalogs/complementos/cartaporte/ClaveRegimenAduanero';

class CartaPorteRegimenesAduanerosListDescription extends Component {
  getClaveRegimenAduaneroCatalogByValue = (value) => {
    if (!value) {
      return null;
    }

    return ClaveRegimenAduanero.filter((item) => item.value === value)[0] ?? null;
  };

  render() {
    const { data } = this.props;
    const { RegimenAduanero } = data;
    const option = this.getClaveRegimenAduaneroCatalogByValue(RegimenAduanero);

    return <>{option.label}</>;
  }
}

export default React.memo(CartaPorteRegimenesAduanerosListDescription);
